import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { LoginService, SystemBroadcastService } from '@pxl/models/contracts';
import { SystemBroadcastModel, SystemBroadcastService as BackendSystemBroadcastService } from '@pxl/shared/generated';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultSystemBroadcastService implements SystemBroadcastService {
    private readonly backendSystemBroadcastService = inject(BackendSystemBroadcastService);
    private readonly config = inject(CONFIG_TOKEN);
    private readonly loginService = inject(LoginService);

    public getActiveSystemBroadcasts(): Observable<SystemBroadcastModel[]> {
        return this.backendSystemBroadcastService.getActiveSystemBroadcasts(this.config.API_VERSION, this.loginService.getToken());
    }
}
